"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tagPickerInputClassNames: function() {
        return tagPickerInputClassNames;
    },
    useTagPickerInputStyles_unstable: function() {
        return useTagPickerInputStyles_unstable;
    }
});
const _react = require("@griffel/react");
const tagPickerInputClassNames = {
    root: 'fui-TagPickerInput'
};
const useBaseStyle = /*#__PURE__*/ (0, _react.__resetStyles)("r1hdk6fw", null, [
    ".r1hdk6fw{background-color:var(--colorTransparentBackground);color:var(--colorNeutralForeground1);font-family:var(--fontFamilyBase);box-sizing:border-box;border:none;min-width:24px;max-width:100%;width:var(--fluent-TagPickerInput__width, 0);flex-grow:1;}",
    ".r1hdk6fw:focus{outline-style:none;}",
    ".r1hdk6fw::-webkit-input-placeholder{color:var(--colorNeutralForeground4);opacity:1;}",
    ".r1hdk6fw::-moz-placeholder{color:var(--colorNeutralForeground4);opacity:1;}",
    ".r1hdk6fw::placeholder{color:var(--colorNeutralForeground4);opacity:1;}",
    ".r1hdk6fw::after{visibility:hidden;white-space:pre-wrap;}"
]);
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    medium: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "fa2pw7h"
    },
    large: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "ft37c3"
    },
    "extra-large": {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f3abo53"
    },
    disabled: {
        sj55zd: "f1s2aq7o",
        De3pzq: "f1c21dwh",
        Bceei9c: "fdrzuqr",
        yvdlaj: "fahhnxm"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        [
            ".fa2pw7h{padding:var(--spacingVerticalSNudge) 0 var(--spacingVerticalSNudge) 0;}",
            {
                p: -1
            }
        ],
        [
            ".ft37c3{padding:var(--spacingVerticalMNudge) 0 var(--spacingVerticalMNudge) 0;}",
            {
                p: -1
            }
        ],
        [
            ".f3abo53{padding:var(--spacingVerticalM) 0 var(--spacingVerticalM) 0;}",
            {
                p: -1
            }
        ],
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".fdrzuqr{cursor:not-allowed;}",
        ".fahhnxm::-webkit-input-placeholder{color:var(--colorNeutralForegroundDisabled);}",
        ".fahhnxm::-moz-placeholder{color:var(--colorNeutralForegroundDisabled);}"
    ]
});
const useTagPickerInputStyles_unstable = (state)=>{
    'use no memo';
    const baseStyle = useBaseStyle();
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(tagPickerInputClassNames.root, baseStyle, styles[state.size], state.disabled && styles.disabled, state.root.className);
    return state;
}; //# sourceMappingURL=useTagPickerInputStyles.styles.js.map
